import { Link } from "react-router-dom";
import { LangLink } from "@/components/LangLink";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { SmartImage } from "@/components/SmartImage";
import { formatPrice } from "@/lib/api";

// Editorial product card \u2014 gallery image on white, hairline divider, animated saffron underline.
export const ProductCard = ({ product, index = 0 }) => (
  <motion.article
    initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-6%" }}
    transition={{ duration: 0.5, delay: (index % 4) * 0.04, ease: [0.22, 1, 0.36, 1] }}
    className="group" data-testid="product-card">
    <LangLink to={`/product/${product.handle}`} data-testid="product-card-link" className="block">
      <div className="relative aspect-[4/5] overflow-hidden bg-white">
        {product.image ? (
          <SmartImage src={product.image} alt={product.title}
            className="absolute inset-0 h-full w-full"
            imgClassName="h-full w-full object-contain p-4 transition-transform duration-700 ease-out group-hover:scale-[1.05]" />
        ) : (
          <div className="flex h-full items-center justify-center text-xs text-muted-foreground">No image</div>
        )}
        {product.badge && (
          <span className="absolute left-3 top-3 bg-header px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-white">{product.badge}</span>
        )}
        <span className="absolute right-3 top-3 flex h-9 w-9 translate-y-1 items-center justify-center rounded-full bg-header text-white opacity-0 transition-all duration-200 group-hover:translate-y-0 group-hover:opacity-100">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
      <div className="border-t border-foreground/10 pt-3">
        {product.brand && (
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">{product.brand}</p>
        )}
        <h3 className="mt-1 line-clamp-2 text-sm leading-snug text-foreground">
          <span className="link-underline">{product.title}</span>
        </h3>
        <p className="mt-1.5 text-sm font-semibold">{product.price && formatPrice(product.price)}</p>
      </div>
    </LangLink>
  </motion.article>
);
